
import React, { createContext, useState, useContext } from 'react';

const FormContext = createContext();

export const useForm = () => {
    return useContext(FormContext);
};

export const FormProvider = ({ children }) => {
    const [formData, setFormData] = useState({});

    const updateFormData = (newData) => {
        setFormData(prevData => ({ ...prevData, ...newData }));
    };

    const value = {
        formData,
        updateFormData,
    };

    return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};
